import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { first, map, Observable, of } from 'rxjs';
import { UtagHelperService } from '../../../services/utag-helper.service';
import { HttpPrepareCallService } from '../../../../core/services/http-prepare-call/http-prepare-call.service';
import { IAvailableDocumentLanguages } from '../../../../models/language/available-document-languages.model';
import { Store } from '@ngrx/store';
import { setDocumentSession } from '../../../../redux/mydoc.action';
import { cloneDeep } from 'lodash';
import { IDocumentSimpleType } from '../../../../models/document/document-simple-type.model';

@Injectable({
  providedIn: 'root',
})
export class MydocumentsItemAdapterService extends HttpPrepareCallService {
  public constructor(
    private readonly translocoService: TranslocoService,
    protected override readonly httpClient: HttpClient,
    protected override utagHelperService: UtagHelperService,
    private store: Store
  ) {
    super(httpClient, utagHelperService);
  }

  getAvailableDocumentLanguages(): Observable<IAvailableDocumentLanguages[]> {
    let languageCodes = "'EN'";
    if (this.site_language) {
      languageCodes += `, '${this.site_language.toUpperCase()}'`;
    }

    return this.httpClient
      .get(
        `${this.apiUrl}mydocuments/AvailableDocumentLanguages?$expand=text($filter=language in (${languageCodes}))`,
        {
          headers: { APIKey: this.apiKey, Accept: 'application/json' },
          withCredentials: true,
        }
      )
      .pipe(
        map((response: any) => {
          return <IAvailableDocumentLanguages[]>response?.value;
        })
      );
  }

  getDocumentTypeOrder(documentLanguage: string): Observable<any> {
    return this.httpClient
      .get(
        `${
          this.apiUrl
        }mydocuments/DocumentType?$expand=text($filter=language in (${
          documentLanguage === 'EN' ? "'EN'" : `'EN', '${documentLanguage}'`
        }))`,
        {
          headers: {
            APIKey: this.apiKey,
            Accept: 'application/json',
          },
          withCredentials: true,
        }
      )
      .pipe(
        map((response: any) => {
          return response?.value;
        })
      );
  }

  myDocumentSessionGet(
    sessionId: string,
    orderNumber: string
  ): Observable<any> {
    const header: HttpHeaders = <any>{
      APIKey: this.apiKey,

      Accept: 'application/json',
    };

    return this.httpClient
      .options(
        `${this.apiUrl}mydocuments/getItemsByTokenAndCheckTokenAndOrderNoData(token='${sessionId}',orderNo='${orderNumber}')
        `,
        {
          headers: header,
          withCredentials: true,
        }
      )
      .pipe(first(), () => {
        return this.httpClient
          .get(
            `${this.apiUrl}mydocuments/getItemsByTokenAndCheckTokenAndOrderNoData(token='${sessionId}',orderNo='${orderNumber}')
        `,
            {
              headers: header,
              withCredentials: true,
            }
          )
          .pipe(
            map((response: any) => {
              this.hookUrl = response?.hookURL;
              this.sessionType = response?.type;
              this.defaultLanguage = this.site_language.toLowerCase();
              this.translocoService.setActiveLang(this.defaultLanguage);
              this.activeLanguageChanged.next(this.defaultLanguage);
              this.customer_role = response?.roleScenario;
              this.customer_subrole = response?.role;

              this.store.dispatch(
                setDocumentSession({ documentSession: cloneDeep(response) })
              );
              return response;
            })
          );
      });
  }

  public postSaveUserEntriesV2(
    token: string,
    orderNo: string,
    docLanguages: string,
    selectedProducts: string,
    documentTypes: IDocumentSimpleType[],
    documentSubTypes: IDocumentSimpleType[]
  ): Observable<any> {
    return this.httpClient.post<any>(
      `
      ${this.apiUrl}mydocuments/saveUserEntries
      `,
      {
        token,
        orderNo,
        docLanguages,
        selectedProducts,
        documentTypes,
        documentSubTypes,
      },
      {
        headers: {
          APIKey: this.apiKey,
          Accept: 'application/json',
        },
        withCredentials: true,
      }
    );
  }

  getCatFileDocumentTypes(docLanguages: string): Observable<any> {
    return this.httpClient.get(
      `
      ${this.apiUrl}mydocuments/DocumentType?$filter=docTypeId eq 11&$expand=subTypes($expand=cadFormatText($filter=language eq '${docLanguages}'),cadFileTypeText($filter=language eq '${docLanguages}')),text($filter=language eq '${docLanguages}')
      `,
      {
        headers: {
          APIKey: this.apiKey,
          Accept: 'application/json',
        },
        withCredentials: true,
      }
    );
  }
}
